<script src="../../../../store/module/accountserv.js"></script>
<template>
  <Modal
    v-model="_value"
    width="400"
    title="查看/修改个人资料"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="userInfo">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">用户名</label>
        <Input style="display: inline-block; width: 250px;" :disabled="true" v-model="userInfo.name"
               placeholder="请输入用户名">
        </Input>
      </FormItem>
      <FormItem prop="nickName">
        <label style="display: inline-block; width: 60px;">昵称</label>
        <Input style="display: inline-block; width: 250px;" :disabled="!modify" v-model="userInfo.nickName"
               placeholder="请输入昵称">
        </Input>
      </FormItem>
      <FormItem prop="realName">
        <label style="display: inline-block; width: 60px;">真实姓名</label>
        <Input style="display: inline-block; width: 250px;" :disabled="true" v-model="userInfo.realName"
               placeholder="请输入真实姓名">
        </Input>
      </FormItem>
      <FormItem prop="sex">
        <label style="display: inline-block; width: 60px;">性别</label>
        <Select :disabled="!modify" v-model="userInfo.sex"
                style="width:250px">
          <Option v-for="item in userSex" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="mobilePhoneNum">
        <label style="display: inline-block; width: 60px;">手机号码</label>
        <Input style="display: inline-block; width: 250px;" :disabled="true" v-model="userInfo.mobilePhoneNum"
               placeholder="请输入手机号码">
        </Input>
      </FormItem>
      <FormItem prop="introduction">
        <label style="display: inline-block; width: 60px;">简介</label>
        <Input style="display: inline-block; width: 250px;" :disabled="!modify" type="textarea"
               v-model="userInfo.introduction" placeholder="请输入简介">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <Button type="primary" @click="modifyPasswordModal=true" style="margin-right: 10px;">修改密码</Button>
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
    <modify-password-modal v-model="modifyPasswordModal"></modify-password-modal>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  import ModifyPasswordModal from '@/view/acl/components/modify-password-modal'

  export default {
    name: 'SelfInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    components: {
      ModifyPasswordModal
    },
    data() {
      return {
        modifyPasswordModal:false,
        modify: false,
        userSex: [
          {label: '女', value: 0},
          {label: '男', value: 1},
          {label: '未知', value: 2},
        ],
        userInfo: {
          id: null,
          name: null,
          nickName: null,
          realName: null,
          sex: 2,
          mobilePhoneNum: null,
          introduction: null,
          avatarUrl:null
        }
      }
    },
    methods: {
      ...mapActions([
        'AccountServ_GetSelfInfo',
        'AccountServ_ModifySelfInfo'
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修个人资料',
            content: '<p>确认修个人资料</p>',
            onOk: () => {
              store.dispatch('AccountServ_ModifySelfInfo', {
                params: this.userInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              })
            },
            onCancel: () => {
              store.dispatch('AccountServ_GetSelfInfo', {
                params: null
              }).then(() => {
                this.userInfo = store.getters.get_Account_GetSelfInfoResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          })
        }
      },
      visibleChange(val) {
        if (val) {
          this.modify = false
          this.userInfo.id = null
          this.userInfo.name = null
          this.userInfo.nickName = null
          this.userInfo.realName = null
          this.userInfo.sex = 2
          this.userInfo.mobilePhoneNum = null
          this.userInfo.introduction = null
          store.dispatch('AccountServ_GetSelfInfo', {
            params: null
          }).then(() => {
            this.userInfo = store.getters.get_Account_GetSelfInfoResult;
          }).catch(err => {
            this.$Message.error(err)
          })

        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
